import { memo, useState } from 'react';
import './style.scss';
import { Divider, Row, Select, Popconfirm, Tag, Empty, Radio, Button, message, Col } from 'antd';
import stl from 'string-to-color';
import useLogout from '../../hooks/useLogout';
import { useGetCompanyListMinimal } from '../../hooks/useCompanies';
import { useGetAllBoxesOfOrder, useGetAllPIIOfOrder, useGetOrderListMinimal, useProcessInboundDraft } from '../../hooks/useOrders';
import DraftPiiList from '../../components/DraftPiiList';
import DebounceInput from '../../commonComponents/DebounceInput';

const DraftPII = () => {
    const [searchName, setSearchName] = useState('');
    const logout = useLogout();

    const getHeaders = () => {
        return (
            <div className="d-flex pii-header">
                <div className="select-div">
                    <h5 style={{ whiteSpace: 'nowrap' }}>Box Name: </h5>
                    <DebounceInput
                        searchName={searchName}
                        setSearchName={setSearchName}
                        style={{ minWidth: '125px' }}
                        placeholder="Search by Box Name"
                        size="small"
                        allowClear={true}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="pii-container">
            {getHeaders()}
            <Divider style={{ margin: '5px 0', padding: 0 }} />
            <DraftPiiList searchName={searchName} setSearchName={setSearchName} />
        </div>
    );
};

export default memo(DraftPII);
